export default function EasyToReach() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#444c42] mb-4">
            Easy to <strong>Reach</strong>
          </h2>
          <div className="w-24 h-1 bg-[#D0A24F] mx-auto mt-6"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Free Parking */}
          <div className="bg-gradient-to-br from-[#F5F5F0] to-white p-8 rounded-2xl shadow-lg">
            <div className="w-16 h-16 bg-[#D0A24F] rounded-full flex items-center justify-center mb-6">
              <i className="ri-parking-box-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#444c42] mb-4">Free Parking Available</h3>
            <p className="text-base text-[#7A8178] mb-4 leading-relaxed">
              Conveniently located in Chelmsford with excellent transport links and free parking for all patients.
            </p>
            <p className="text-base text-[#7A8178] mb-4 leading-relaxed">
              We offer three hours of complimentary onsite parking in our large, spacious car park, making every visit stress-free.
            </p>
            <p className="text-base text-[#444c42] font-semibold leading-relaxed">
              No need to worry about fees or time limits – enjoy convenient, free parking right outside the practice.
            </p>
          </div>

          {/* Train Links */}
          <div className="bg-gradient-to-br from-[#F5F5F0] to-white p-8 rounded-2xl shadow-lg">
            <div className="w-16 h-16 bg-[#D0A24F] rounded-full flex items-center justify-center mb-6">
              <i className="ri-train-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#444c42] mb-4">Train Links</h3>
            <p className="text-base text-[#7A8178] mb-4 leading-relaxed">
              With the new <strong>Beaulieu Park Station (CM3 3QW)</strong> now open, travelling to our practice is easier than ever. Direct trains from London Liverpool Street and other major destinations make distance no longer a concern.
            </p>
            <p className="text-base text-[#444c42] font-semibold leading-relaxed">
              Convenient bus connections from the station bring you close to Beaulieu Dental, ensuring a smooth journey even for long-distance patients.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
